import {
  getPreferenceTagsKey,
  useCreatePreferenceTag,
} from 'api-hooks/preference-tag';
import { KIND, Notification } from 'baseui/notification';
import { NavigationRoutes } from 'common/constants';
import { PreviousNavigation } from 'common/helpers/previous-navigation';
import { queryClient } from 'common/repositories/query-client';
import notification from 'components/common/notification';
import useGetCrudPermission from 'hooks/use-get-crud-permission';
import useNavigation from 'hooks/use-navigation';
import { SeparatorVertical } from 'legacy-modules/styles';
import * as React from 'react';
import { NavigationProps } from 'types';

import PreferenceTagForm from './components/form';

export type PreferenceTagCreateParams = null;

export default function PreferenceTagCreate(
  props: NavigationProps<NavigationRoutes.PreferenceTagsCreate>,
) {
  const { navigate, back } = useNavigation();

  const { mutateAsync, error } = useCreatePreferenceTag();
  const permission = useGetCrudPermission('preference-groups');
  return (
    <>
      {!!error && !!error.message && (
        <>
          <Notification
            overrides={{
              Body: { style: { width: 'auto', wordBreak: 'break-all' } },
            }}
            kind={KIND.negative}
            closeable
          >
            {() => error.message}
          </Notification>
          <SeparatorVertical $margin={8} />
        </>
      )}
      <PreferenceTagForm
        {...props}
        onSubmit={async (input, form) => {
          const result = await mutateAsync(input);

          queryClient.refetchQueries([getPreferenceTagsKey()[0]]);

          const prevPath = PreviousNavigation.get();
          if (prevPath) {
            PreviousNavigation.remove();
            back();
          } else if (permission.view) {
            navigate(NavigationRoutes.PreferenceTagsView, {
              id: result.data?.id,
            });
          }

          notification.success({ message: result?.message });

          return result.data;
        }}
      />
    </>
  );
}
